import { Component, Input } from '@angular/core';
import { FreetextAnswerSummaryModel } from '../../api/models/answer-summary-model';

@Component({
  selector: 'app-freetext-summary',
  templateUrl: './freetext-summary.component.html',
  standalone: false,
})
export class FreetextSummaryComponent {
  @Input({ required: true }) summary!: FreetextAnswerSummaryModel;
}
